import { useRef,  useState , memo , useCallback} from 'react';
import Map from '../components/map/Map.js'
import Grid from '@mui/material/Grid'
import {useFetchBarrierFrees} from '../hooks/useFetchBarrierFrees'
import {useFetchToilet} from '../hooks/useFetchToilet'
import {Marker ,  Tooltip} from 'react-leaflet'
import Header from "../components/Header";
import MapControlBarrierFree from '../components/map/MapControlBarrierFree.js'
import MapCardBarrierFree from '../components/map/MapCardBarrierFree.js'
import MapListBarrierFree from '../components/map/MapListBarrierFree.js'
import { useParams, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {useSharedLang} from '../hooks/useSharedLang.js';
import {LANGS , BARRIER_FREE, getInsta360Url , geoPositionOptions} from "../components/constants.js";
import {useGeolocated} from '../hooks/useGeolocated';
import Loading from "../components/Loading.js";
import {getLink ,getIcon , getTooltipOptions} from "../utils/UrlUtil.js";
import {isToilet} from "../components/constants.js";

const BarrierFree = memo(() => {
  const mapRef = useRef(null);

  //jsonデータを取得
  const {dataList, isLoading} = useFetchBarrierFrees();
  const {toiletList, isToiletLoading} = useFetchToilet();
  //未選択時に初期設定されるデータ ※初期設定不要ならばnullになる
  const defaultSelectData = useRef(null);
  //未選択時に初期設定するかどうか
  const isUseDefaultSelectData = useRef(true);

  const activeBarrierFreeList = useRef(null);

  //検索から選択されたバリアフリーIDを取得 ※idが空は検索以外の遷移
  const { id , group} = useParams();
  //選択されているカテゴリのリストを格納（カテゴリコントローラの選択状態）
  const [selectedGroupList, setSelectedGroupList] = useState([
    BARRIER_FREE.ELEVATOR.code,
    BARRIER_FREE.TOILET.code,
    BARRIER_FREE.SLOPE.code
  ]);
  //選択されているデータ
  const [selectedData , setSelectedData] = useState(null);
  
  //絞り込み・アクティブ状態
  const [isNarrowDown , setIsNarrowDown] = useState(false);
  //一覧表示状態
  const [isList , setIsList] = useState(false);
  //選択されているマーカーの識別子（データID＋座標）※1つのデータに複数座標あるので座標情報含めてマーカーは一意
  const selectedMarkerKey = useRef(null);
  const navigate = useNavigate();

  //--- 多言語対応 ---
  const { t } = useTranslation();
  const { sharedLang } = useSharedLang();

  /**
   * リアルタイム座標チェック
   * 
   * @param {*} pos 
   */
  const setCurrentPosition = (pos) => {
    //現在地をマップに表示
    if(mapRef.current != null){
        mapRef.current.updateMarker(pos.coords.latitude, pos.coords.longitude);
        lastCoords.current =  pos;
    }
  };
  //--- 現在地 ---
  //useGeolocated の coordsは使わない。使うと座標が更新されるたびに画面が再描写してしまう。
  const { isGeolocationAvailable, isGeolocationEnabled  } = useGeolocated({
      ...geoPositionOptions , 
      onSuccess : (pos) => setCurrentPosition(pos),
  });
  const lastCoords = useRef(null);

  const isActiveMarker = useCallback((markerkey) => {
    return selectedMarkerKey.current === markerkey;
  },[]);

  const returnUrl = useCallback(() => {
    let group = selectedGroupList.join('-');
    if(isToilet(selectedData)){
      return getLink(selectedData, '/barrier-free/')  + '/' + group
    }
    return getLink(selectedData)  + '/' + group
  },[selectedData]);


  const modalOpen = useCallback(() => {
    let group = selectedGroupList.join('-');
    navigate(
        '/modal360', 
        { state: { link360: getInsta360Url(selectedData) ,returnUrl: returnUrl()}
    });
  },[selectedData]);


  const getMarkerKey = useCallback((flower , coordinate) => {
    return flower.id + '-' + coordinate[0] + '-' + coordinate[1];
  },[]);

  const toggleGroupControl = useCallback((codes) => {
    setSelectedGroupList(codes);
  },[]);

  const toggleNarrowDown = useCallback((flg) => {
    setIsNarrowDown(flg);
  },[]);

  const toggleList = useCallback((flg) => {
    setIsList(flg);
    setIsNarrowDown(false);
  },[]);

  const clickMarker = (row, coordinate) => {
    selectedMarkerKey.current = getMarkerKey(row, coordinate);
    setSelectedData(row);
  };

  const selectData = (data) => {
    selectedMarkerKey.current = null;
    setIsNarrowDown(true);
    setSelectedData(data);
    setIsList(false);
  };

  const resetMarker = useCallback(() => {
    selectedMarkerKey.current = null;
    isUseDefaultSelectData.current = false;

    setSelectedData(null);
    setIsNarrowDown(false);
  },[]);
  
  const getActiveDataList = () => {
    let elements = [];
    if(isLoading || isToiletLoading){
      return elements;
    }
    let currentElement = getActiveElement();
    let allList = dataList.concat(toiletList);

    allList.forEach(row => {

      //トイレは多目的があるものが対象
      if((row.isBarrierFree === false) && row.category === "toilet"){
        //関数（ブロック）を抜けて次の処理へ
        return;
      }

      if(sharedLang === LANGS.ENGLISH){
        row.name = row.nameEnglish;
        row.description = row.descriptionEnglish;
        row.catchcopy = row.catchcopyEnglish;
      }
      if(row.path === ''){
        row.path = 'no-image@3x.png';
      }
      var barrier = row.category;
      if(selectedGroupList.includes(barrier)){
        elements.push(row);
      }
    })
    return elements;
  };

  const getActiveElement = useCallback(() => {
      let ret = selectedData;
      if(selectedData == null && isUseDefaultSelectData.current){
          ret = defaultSelectData.current;
      }
      return ret;
  },[selectedData]);

  if (isLoading) {
    return (<Loading></Loading>);
  }
  activeBarrierFreeList.current = getActiveDataList();

  if(id && defaultSelectData.current == null){
    activeBarrierFreeList.current.forEach((row) =>{
      if(String(row.id) === id){
        defaultSelectData.current = row;
        selectData(row);
        setSelectedGroupList(group.split('-'));
        selectedMarkerKey.current = getMarkerKey(
            row,
            [row.positions[0].latitude , row.positions[0].longitude]
        );
      }
    })
  }

  return (
    <>
    <Header 
      display={true} 
      title={t("barrier.title")}
      isList={isList} 
      toggleList={toggleList} />
    
    <Grid container justifyContent="center" alignItems="center" direction="column">
      {isList?
      <MapListBarrierFree 
        dataList={activeBarrierFreeList.current}
        selectData={selectData}
      />  :
      <>
      <Map ref={mapRef}>
      {
        activeBarrierFreeList.current.map((row, fIndex) =>
            row.positions.map((position, pIndex) => {
              let coordinate = [position.latitude, position.longitude];
              let markerKey = getMarkerKey(row, coordinate);
              
              return <Marker
                  key={markerKey}
                  position={coordinate}
                  icon={getIcon(row.markerIcon)}
                  eventHandlers={{
                    click: (e) => {
                      clickMarker(row, coordinate);
                    }
                  }}
                >
                {
                isActiveMarker(markerKey)
                //true
                ?<Tooltip
                  {...getTooltipOptions(
                      fIndex + pIndex , 
                      coordinate,
                      row.category
                  )}
                  >
                    {row.name}
                  </Tooltip>
                : <></>
                }
              </Marker>
            })
        )
      }
        {
          selectedData == null 
          ? <MapControlBarrierFree 
                selectedGroupList={selectedGroupList} 
                toggleGroupControl={toggleGroupControl} />
          : <></>
        }
    </Map>
    <MapCardBarrierFree 
      data={getActiveElement()} 
      resetMarker={resetMarker} 
      isNarrowDown={isNarrowDown} 
      toggleNarrowDown={toggleNarrowDown} 
      modalOpen = {modalOpen}  
      returnUrl = {returnUrl}
    />
    </>
    }    
  </Grid>
  </>
  )
});
export default BarrierFree